import { Typography } from '@scale/scaleui';
import { ISensorFusionUnifiedProjectLookupDto } from '@scale/sensor-fusion-shared';
import GeneralPipelineNodeGraph from 'react-scale/corp/components/Lookup/sections/PipelineV3Graphs/GeneralPipelineNodeGraph';

type SfuPipelinePanelProps = {
  project: ISensorFusionUnifiedProjectLookupDto;
};

const SfuPipelinePanel = ({ project }: SfuPipelinePanelProps) => {
  return (
    <div className="border border-solid border-neutral-200 px-4 py-4 flex flex-col gap-2">
      <Typography.H3>Project Pipeline</Typography.H3>

      <GeneralPipelineNodeGraph
        nodes={project.stageDefinitions.map(stage => ({
          ...stage,
          count: Object.values(stage.statusCounts).reduce((outerResult, statusGroup) => {
            return (
              outerResult +
              Object.values(statusGroup).reduce((innerResult, value) => {
                return innerResult + value;
              }, 0)
            );
          }, 0),
        }))}
      />
    </div>
  );
};

export default SfuPipelinePanel;
